const formatTime = date => {
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()
//   const hour = date.getHours()
//   const minute = date.getMinutes()
//   const second = date.getSeconds()
//   ${[hour, minute, second].map(formatNumber).join(':')}
    // return `${[year, month, day].map(formatNumber).join('/')} ${[hour, minute, second].map(formatNumber).join(':')}`
  return `${[year, month, day].map(formatNumber).join('-')}`
}
const formatTimestamp = date => {
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const day = date.getDate()
    const hour = date.getHours()
    const minute = date.getMinutes()
    const second = date.getSeconds()
  //   ${[hour, minute, second].map(formatNumber).join(':')}
    return `${[year, month, day].map(formatNumber).join('-')} ${[hour, minute, second].map(formatNumber).join(':')}`
  }
const formatNumber = n => {
  n = n.toString()
  return n[1] ? n : `0${n}`
}



function urlRegEx(url){
    let spits = url.split('?')
    var filePath = spits[0]
    var fileExtension = filePath.substring(filePath.lastIndexOf('.') + 1)
    return fileExtension
}

module.exports = {
  formatTime,formatTimestamp,urlRegEx
}
